export const stepMap = {
  borrower: 1,
  property: 2,
  thirdparty: 3,
  experience: 4,
  declarations: 5,
}
export const stepNumMap = {
  1: 'borrower',
  2: 'property',
  3: 'thirdparty',
  4: 'experience',
  5: 'declarations',
}
